import React, { Component } from 'react';
import { Spin } from 'antd';
import { getNamesByLanguage } from '../../constants';
import FooterButton from '../Components/FooterButton';
import Summary from './Table/Summary';
import Resolve from './Table/Resolve';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

let names = {};

class Total extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [
                {num: '1', projectName: 'CRC服务', amountA: '6048000', amountB: '2520000‬', expenseProportion: '39.82%'},
                {num: '2', projectName: '其他CRC服务', amountA: '2520000‬', amountB: '2520000‬', expenseProportion: '16.59%'},
                {num: '3', projectName: '总计', amountA: '10071400', amountB: '10071400', expenseProportion: '100.00%'},
                {num: '4', projectName: '优惠折扣', amount: ''},
                {num: '5', projectName: '税', amount: ''},
                {num: '6', projectName: '合计', amount: ''},
            ],
            resolveData: [
                {num: '1', resolve: '平均每例受试者的CRC服务费', amount: '5142719'},
                {num: '2', resolve: '每例受试者每次访视的服务费', amount: '514272'},
            ],
            loading: false,
            editable: false,
            tax: '',
            discount: '',
        };
    }

    componentDidMount() {
        const { status, language } = this.props;
        let editable = false;
        if (status === 'add') {
            editable = true;
        }
        this.setState({ editable });
        names = getNamesByLanguage('total', language);
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const len = data.length;
        const showIaIb = false;
        // 服务费合计
        const total = Number(data[len - 4].amountA || 0) + (showIaIb ? Number(data[len - 4].amountB || 0) : 0);
        // 优惠金额
        if (key === 'discount') {
            data[index].amount = (total * value / 100).toFixed(2);
        // 税
        } else {
            data[index].amount = ((total - (Number(data[len - 3].amount) || 0)) * value / 100).toFixed(2);
        }
        // 合计
        data[len - 1].amount = (total - (Number(data[len - 3].amount) || 0) + (Number(data[len - 2].amount) || 0)).toFixed(2);
        this.setState({
            data,
            [key]: value,
        });
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            const { status } = this.props;
            status === 'add' && this.props.changeStep(1);
        }
    }

    toggleEditable = (editable) => {
        this.setState({ editable });
    }

    render() {
        const { status, height, mode } = this.props;
        const { data, prevData, resolveData, loading, editable, tax, discount } = this.state;
        const summarySetting = {
            mode,
            names,
            data,
            prevData,
            editable,
            showIaIb: false,
            tax,
            discount,
        };
        const resolveSetting = {
            mode,
            names,
            data: resolveData,
        }
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    <h2 className="quotation-title">{names.title}</h2>
                    <Summary {...summarySetting} onChange={this.handleChange} />
                    <Resolve {...resolveSetting} />
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
            </Spin>
        );
    }
}

export default Total;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Total/index.js